import { useState, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

const useDeleteCommunicationInput = () => {
  const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const deleteCommunicationInput = useCallback(
    async (id: number): Promise<boolean> => {
      if (!isReady) return false;
      setIsLoading(true);
      setError('');
      try {
        await authFetch(`/communication_inputs/${id}`, { method: 'DELETE' });
        return true;
      } catch (err: unknown) {
        setError(err instanceof Error ? err.message : 'Erreur lors de la suppression');
        return false;
      } finally {
        setIsLoading(false);
      }
    },
    [authFetch, isReady],
  );

  return { deleteCommunicationInput, isLoading, error };
};

export default useDeleteCommunicationInput;
